import {
  Icon,
  Icons,
  TypographyElement
} from 'UI'

import { createUseStyles, useTheme } from 'react-jss'
import style from './style'
import { CartPath } from 'navigation/Routes'
import { memo } from 'react'

const useStyle = createUseStyles(style)

export default memo(({ cartItems, goToLink }) => {
  const theme = useTheme()
  const { iconClass, containerClass, redBadge, anchorClass } = useStyle()
  return (
    cartItems.length
      ? (
        <a href={CartPath} onClick={e => e.preventDefault()} className={anchorClass}>
          <div
            data-test='cart-link'
            className={containerClass}
            onClick={() => goToLink(CartPath)}
          >
            <Icon iconName={Icons.shoppingCart} style={iconClass} key={`shoppingCart${cartItems.length}`} />
            <div className={redBadge} key={`redBadge${cartItems.length}`}>
              <TypographyElement
                variant='caption'
                align='left'
                color={theme.neutral[400]}
                fontSize={8}
              >
                {cartItems.length}
              </TypographyElement>
            </div>
          </div>
        </a>
        )
      : null
  )
})
